function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "1194FC85-A5A4-44D5-B01E-08A986E5C0D4");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83D\\uDCF1-Tablet",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Products",
  transform: "translate(-601.000000, -386.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(536.000000, 250.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Elements/Card/Icon+Text",
  transform: "translate(0.000000, 96.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "card"
}, /*#__PURE__*/React.createElement("g", {
  id: "illustrations/glasses",
  transform: "translate(65.000000, 40.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "glasses",
  transform: "translate(-0.000000, -0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "bound",
  points: "0 0 56 0 56 56 0 56"
}), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(0.000000, 12.833333)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.5,14.5833333 C39.9372346,15.0624115 40.1301705,17.1407972 39.4659922,18.1845059 C38.801814,19.2282145 37.7937087,19.3308449 36.75,18.6666667 C34.0149715,16.926194 30.3333333,18.0833333 29.1666667,19.25 C28.2911722,20.1254945 26.8784743,20.4920269 26.0036999,19.6172525 C25.1749662,18.7885189 25.1313486,17.4719766 25.8728472,16.5918947 C27.9352554,14.475076 30.1998619,13.4166667 32.6666667,13.4166667 C35.5833333,13.4166667 36.75,14 38.5,14.5833333 Z M8.064,2.688 C9.84266489,4.02199867 12.6008099,8.29867302 16.8226951,16.0228038 C17.4160362,17.1083483 17.0170265,18.469354 15.931482,19.0626951 C14.8459374,19.6560362 13.4849317,19.2570265 12.8915906,18.171482 L12.1736383,16.8669493 C8.89037589,10.9435517 6.5558904,7.33063092 5.51574922,6.38839788 L5.43984,6.32128 L5.39414542,6.35379607 C5.11181124,6.56464319 4.72268196,7.00672919 4.27683742,7.69142675 L4.14143268,7.90412574 C3.48745809,8.95425801 2.10600653,9.27540727 1.05587426,8.62143268 C0.00574198866,7.96745809 -0.315407267,6.58600653 0.338567321,5.53587426 C2.52189814,2.02994881 5.3207183,0.630538729 8.064,2.688 Z M45.024,1.568 C46.7375287,2.8531465 49.8555832,7.10293931 54.8169442,14.7589693 C55.4897229,15.7971549 55.193502,17.1841655 54.1553164,17.8569442 C53.1171308,18.5297229 51.7301202,18.233502 51.0573415,17.1953164 L49.6769299,15.0828019 C46.1307963,9.70403071 43.6749535,6.37271315 42.5633255,5.34439956 L42.39984,5.20128 L42.3541454,5.23379607 C42.0718112,5.44464319 41.682682,5.88672919 41.2368374,6.57142675 L41.1014327,6.78412574 C40.4474581,7.83425801 39.0660065,8.15540727 38.0158743,7.50143268 C36.965742,6.84745809 36.6445927,5.46600653 37.2985673,4.41587426 C39.4818981,0.909948811 42.2807183,-0.489461271 45.024,1.568 Z",
  id: "Combined-Shape",
  fill: "#4072EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.4166667,8.16666667 C25.8934904,8.16666667 30.3333333,12.6065096 30.3333333,18.0833333 C30.3333333,23.5601571 25.8934904,28 20.4166667,28 C14.9398429,28 10.5,23.5601571 10.5,18.0833333 C10.5,12.6065096 14.9398429,8.16666667 20.4166667,8.16666667 Z M46.0833333,8.16666667 C51.5601571,8.16666667 56,12.6065096 56,18.0833333 C56,23.5601571 51.5601571,28 46.0833333,28 C40.6065096,28 36.1666667,23.5601571 36.1666667,18.0833333 C36.1666667,12.6065096 40.6065096,8.16666667 46.0833333,8.16666667 Z",
  id: "Combined-Shape",
  fill: "#9FB8F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.0311236,11.6804781 C47.157811,11.2341919 47.6222978,10.9751059 48.0685839,11.1017933 C50.4898106,11.7891075 52.3934374,13.6993939 53.0719953,16.1233462 C53.1970563,16.5700908 52.9362803,17.0336309 52.4895357,17.158692 C52.0427911,17.283753 51.579251,17.022977 51.4541899,16.5762324 C50.9332545,14.7153411 49.4686437,13.2456064 47.6098084,12.7179384 C47.1635223,12.591251 46.9044363,12.1267642 47.0311236,11.6804781 Z",
  id: "Path",
  fill: "#FFFFFF"
})))))))));

var SvgGlasses = function SvgGlasses(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlasses, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glasses.46ca6ac5.svg";
export { ForwardRef as ReactComponent };